$(document).scroll(() => {
  let top_of_element = $("#shopify-section-footer").offset().top;
  let bottom_of_element = $("#shopify-section-footer").offset().top + $("#shopify-section-footer").outerHeight();
  let bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
  let top_of_screen = $(window).scrollTop();

  if (top_of_element < (top_of_screen + $("#shopify-section-header").outerHeight() + $(".scrollbar-slider").outerHeight())){
    // the footer is visible, so hide the scrollbar
    $(".scrollbar-slider.fixed").hide();
  } else {
      // the footer is not visible, show the scrollbar
    $(".scrollbar-slider.fixed").show();
  }
})

function closeKlaviyoLaunchModal() {
  $("#klaviyoLaunchModal").hide();
}

$(document).ready(function() {

  let params = new URL(document.location).searchParams;
  // zodiac = true
  if (params.get("zodiac") === 'true') {
      if (window.innerWidth > 991) {
        $('body').append(`
          <div id="klaviyoLaunchModal" style="
            z-index: 2;
            height: 100px;
            width: 100vw;
            background-color: #FFEBED;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            bottom: 0;
            box-shadow: 0 0px 7px -2px gray;
            border-radius: 14px 14px 0px 0px;
            ">
            <svg onclick="closeKlaviyoLaunchModal()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="
              position: absolute;
              right: 15px;
              top: 15px;
          ">
              <path d="M12.0898 23.1795C18.1891 23.1795 23.1795 18.1891 23.1795 12.0898C23.1795 5.99039 18.1891 1 12.0898 1C5.99039 1 1 5.99039 1 12.0898C1 18.1891 5.99039 23.1795 12.0898 23.1795Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.95135 15.2279L15.2282 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.2282 15.2279L8.95135 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div style="width: 50%;font-size: 18px;text-align: center;">We've recorded your star sign! Stay tuned for a surprise announcement in your inbox soon!</div>
          </div>
      `)
      } else {
        $('body').append(`
          <div id="klaviyoLaunchModal" style="
          z-index: 2;
          height: 100px;
          width: 100vw;
          background-color: #FFEBED;
          display: flex;
          align-items: center;
          justify-content: center;
          position: fixed;
          bottom: 0;
          box-shadow: 0 0px 7px -2px gray;
          border-radius: 14px 14px 0px 0px;
          ">
          <svg onclick="closeKlaviyoLaunchModal()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" style="
              position: absolute;
              right: 5px;
              top: 5px;
          ">
            <path d="M12.0898 23.1795C18.1891 23.1795 23.1795 18.1891 23.1795 12.0898C23.1795 5.99039 18.1891 1 12.0898 1C5.99039 1 1 5.99039 1 12.0898C1 18.1891 5.99039 23.1795 12.0898 23.1795Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.95135 15.2279L15.2282 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M15.2282 15.2279L8.95135 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <div style="width: 80%;font-size: 14px;text-align: center;">We've recorded your star sign! Stay tuned for a surprise announcement in your inbox soon!</div>
        </div>
      `)
      }
      setTimeout(closeKlaviyoLaunchModal, 15000);
  }
    if (params.get("subscribed") === 'true') {
      if (window.innerWidth > 991) {
        $('body').append(`
          <div id="klaviyoLaunchModal" style="
            z-index: 2;
            height: 100px;
            width: 100vw;
            background-color: #FFEBED;
            display: flex;
            align-items: center;
            justify-content: center;
            position: fixed;
            bottom: 0;
            box-shadow: 0 0px 7px -2px gray;
            border-radius: 14px 14px 0px 0px;
            ">
            <svg onclick="closeKlaviyoLaunchModal()" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="
              position: absolute;
              right: 15px;
              top: 15px;
          ">
              <path d="M12.0898 23.1795C18.1891 23.1795 23.1795 18.1891 23.1795 12.0898C23.1795 5.99039 18.1891 1 12.0898 1C5.99039 1 1 5.99039 1 12.0898C1 18.1891 5.99039 23.1795 12.0898 23.1795Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M8.95135 15.2279L15.2282 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M15.2282 15.2279L8.95135 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <div style="width: 50%;font-size: 18px;text-align: center;">Thank you for joining the launch list! You'll be the first to know about new product launches and sales! Keep an eye on your inbox!</div>
          </div>
      `)
      } else {
        $('body').append(`
          <div id="klaviyoLaunchModal" style="
          z-index: 2;
          height: 100px;
          width: 100vw;
          background-color: #FFEBED;
          display: flex;
          align-items: center;
          justify-content: center;
          position: fixed;
          bottom: 0;
          box-shadow: 0 0px 7px -2px gray;
          border-radius: 14px 14px 0px 0px;
          ">
          <svg onclick="closeKlaviyoLaunchModal()" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" style="
              position: absolute;
              right: 5px;
              top: 5px;
          ">
            <path d="M12.0898 23.1795C18.1891 23.1795 23.1795 18.1891 23.1795 12.0898C23.1795 5.99039 18.1891 1 12.0898 1C5.99039 1 1 5.99039 1 12.0898C1 18.1891 5.99039 23.1795 12.0898 23.1795Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.95135 15.2279L15.2282 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M15.2282 15.2279L8.95135 8.95117" stroke="black" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <div style="width: 80%;font-size: 14px;text-align: center;">Thank you for joining the launch list! You'll be the first to know about new product launches and sales! Keep an eye on your inbox!</div>
        </div>
      `)
      }
      setTimeout(closeKlaviyoLaunchModal, 10000);
    }
 
    // // hide panties frequency select
    if ($(".product-page-main-select").length) {
      // alert($(".product-swatch-panties").val())
      $(".product-page-main-select").hide();
    }

    // $.get("/products/midnight-bloom-set/metafields.json").then(data => console.log(data));
    // if (!$('.shop-page-main-stars div .yotpo .yotpo-display-wrapper .yotpo.bottomline').length) {
    //   $('.shop-page-main-stars').hide();
    // }

    // generate date on product page
    function calculateEstimatedDeliveryDate() {
      let today = new Date();
      let estimatedDeliveryDate = new Date();
      estimatedDeliveryDate.setDate(today.getDate() + 5);
    
      let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      let day = days[estimatedDeliveryDate.getUTCDay()];
      
      let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      let month = months[estimatedDeliveryDate.getUTCMonth()];
      let date = estimatedDeliveryDate.getUTCDate();
      let year = estimatedDeliveryDate.getUTCFullYear();
    
      return "Estimated delivery date: " + month + " " + date + ", " + year;
    }

    $("#product-page-main-labs-date").text(calculateEstimatedDeliveryDate());
  
	// Mobile Menu
	$('.mobile-menu-button').on('click', function(){
		$(this).toggleClass('mobile-menu-button-active');
		$('.mobile-menu').toggleClass('mobile-menu-active');
		$('header').toggleClass('header-mobile-menu-active');
		$('html, body').toggleClass('body-overflow');
	});


	$('.search-menu-mobile span').on('click', function () {
		$('.search-menu-mobile').removeClass('search-menu-mobile-active');
		$('.searchresultsmobile').hide();
		$('.mobile-menu').removeClass('mobile-menu-with-search');
	});

	// Search menu desktop
	$('.header-right-menu ul li.search-menu-button').on('click', function(){
		$(this).toggleClass('search-menu-active');
		$('.search-menu-modal').toggleClass('search-menu-modal-active');
	});

	$('.search-menu-desktop-close').on('click', function(){
		$('.header-right-menu ul li.search-menu-button').removeClass('search-menu-active');
		$('.search-menu-modal').removeClass('search-menu-modal-active');
	});

	if ($(".search-menu-desktop").hasClass("search-menu-desktop-active")) {
		$('.search-menu-desktop .search-icon').on('click', function () {
			$('.search-menu-desktop').addClass('search-menu-desktop-active');
			$('.searchresultsdesktop').show();
		});
		} else {
			$('.search-menu-desktop .search-icon').on('click', function () {
				$('.searchresultsdesktop').hide();
				$('#searchdesktop').val('');
				$('#searchdesktop').focus();
			});
	}

	$('.search-menu-desktop span').on('click', function () {
		$('.search-menu-desktop').removeClass('search-menu-desktop-active');
		$('.searchresultsdesktop').hide();
	});

	// Shop Menu hover on desktop
	if ($(window).width() > 991) {
		$(".shop-hover-button").on({
			mouseover: function(e) {
				if (!$('.shop-hover-menu-active')[0]) {
					$('header').addClass('shop-hover-menu-active');
					$('.shop-hover-menu ul').stop().animate({opacity: 1}, 200);
					
				}
			},
		});
		$("header").on({
			mouseleave: function(e) {
				if ($('.shop-hover-menu-active')[0]) {
					$('.shop-hover-menu ul').stop().animate({opacity: 0}, 200);
					$('header').removeClass('shop-hover-menu-active');
				}
			}
		});
	}

	// Cart Menu
	$('.cart-menu').on('click', function () {
		$('.cart-menu-modal').toggleClass('cart-menu-modal-active');
		$('#rebuy-popup-show').show();
		if($(window).width() > 991) {
			$('.cart-menu-scrollable').scroll($.debounce( 200, true, function(){
				$('.cart-menu-modal').addClass('cart-menu-scroll');
			}));
			$('.cart-menu-scrollable').scroll($.debounce( 600, function(){
				$('.cart-menu-modal').removeClass('cart-menu-scroll');
			}));
		} else {
			$('.cart-menu-scrollable').scroll($.debounce( 200, true, function(){
				$('.cart-menu-modal').addClass('cart-menu-scroll');
			}));
			$('.cart-menu-scrollable').scroll($.debounce( 600, function(){
				$('.cart-menu-modal').removeClass('cart-menu-scroll');
			}));
			$('html, body').addClass('body-overflow');
		}
	});

	$('.cart-menu-close').on('click', function () {
		$('.cart-menu-modal').removeClass('cart-menu-modal-active');
		$('html, body').removeClass('body-overflow');
	});


	$(".cart-menu-modal").on("click",".cart-menu-col-right span",function(){
		console.log('remove from database');
		$(this).parent().parent().remove();
	});

	// Footer Slider
	// var swiperfooter = new Swiper(".footer-slider", {
	// 	slidesPerView: "auto",
	// 	spaceBetween: 10,
	// 	loop: true,
	// 	freeMode: true,
	// 	breakpoints: {
	// 		992: {
	// 			spaceBetween: 30,
	// 		},
	// 	  },
	// });

	$("#searchdesktop").on("focus", function() {
		$('.search-menu-desktop').addClass('search-menu-desktop-active');
		$('#searchdesktop').keyup( function() {
			if( this.value.length > 0 ) {
				$('.searchresultsdesktop').show();
				ajaxSearchProducts(this.value, 'desktop');

			}
		});
	});

	if ($(".search-menu-mobile").hasClass("search-menu-mobile-active")) {
		$('.search-icon').on('click', function () {
			$('.search-menu-mobile').addClass('search-menu-mobile-active');
			$('.searchresultsmobile').show();
		});
	} else {
		$('.search-icon').on('click', function () {
			$('.searchresultsmobile').hide();
			$('#searchmobile').val('');
			$('#searchmobile').focus();
		});
	}

	// Search mobile menu
	$("#searchmobile").on("focus", function() {
		$('.search-menu-mobile').addClass('search-menu-mobile-active');
		$('.mobile-menu').addClass('mobile-menu-with-search');
		$('#searchmobile').keyup( function() {
			if( this.value.length > 0 ) {
				$('.searchresultsmobile').show();
				ajaxSearchProducts(this.value, 'mobile');
			}
		});
	});
  // quick add fix
    const ajaxinateContainer = document.getElementById('AjaxinateContainer')
    const observer = new MutationObserver(() => {
      
      if ($(".quick-add-modal-content-active").length) return;
      
      quickAddButtonInit();
  });
    if ($("#AjaxinateContainer").length) {
      observer.observe(ajaxinateContainer, { childList: true, subtree: true });
    } else {
      if ($(".quick-add-modal-content-active").length) return;
      quickAddButtonInit();
    }

	// Drophover
	if ($(window).width() > 991) {
		$(".linked-drophover").on({
			mouseover: function(e) {
				if (!$('.linked-drophover-active')[0]) {
					$('.linked-drophover').addClass('linked-drophover-active');
				}
			},
		});
		$(".linked-drophover").on({
			mouseleave: function(e) {
				$('.linked-drophover').removeClass('linked-drophover-active');
			}
		});
	} else {
		$('.linked-drophover').on('click', function() {
			$('.linked-drophover').not(this).removeClass('linked-drophover-active');
			$(this).toggleClass('linked-drophover-active');
		});

		$('body').on("click", function(e) {
			if ($('.linked-drophover-active')[0]) {
				if ($(e.target).is(".linked-drophover") === false) {
					$('.linked-drophover').removeClass('linked-drophover-active');
				}
			}
		});
	}
});

$(window).on('load', function () {
	setTimeout(function() { 
		$('.instagram-grid-container').attr("style", "display:flex !important;");
		$('#instafeed').attr("style", "max-width:none !important;");
	}, 500);
});

function quickAddButtonInit() {
    $('.quick-add').off('click');
	$('.quick-add').on('click', function(){

		closeQuickModal();

		var product_id = $(this).data('product-id');
		var product_url = $(this).data('product-url');

		$('#quick_modal_product_' + product_id).fadeIn(700);

		$.ajax({
			url: product_url,
			data: {
				view: 'json'
			},
			success: function(data){
				$('#quick_modal_product_' + product_id)
          .empty()
          .html(data)
          .show();
				quickCloseInit();
				swatchInit();
			},
			error: function(data){
				console.log(data);
			}
		});
	});
  $(".quick-add-button").on("click", function () {
    $(".quick-add-modal-content").removeClass("quick-add-modal-content-active");
    $(this)
      .next(".quick-add-modal-content")
      .addClass("quick-add-modal-content-active");
    // if ($(window).width() < 992) {
    //   $("body").addClass("body-modal-open body-overflow");
    // } else {
    //   $("body").removeClass("body-modal-open body-overflow");
    // }
    $("body").addClass("body-modal-open body-overflow");
  });
}

function ajaxSearchProducts(search_value, type) {
	var show_results = 0;

	$.ajax({
    url: '/search',
    data: {
      type: 'product',
      view: 'json',
      q: search_value + '\*',
      prefix: 'last'
    },
    dataType: "json",
    success: function(data){
      var productsHtml = '';
      var elements_count = 0;
      if(data.results_total > 0){
        data.results.forEach((result_object) => {
          if(result_object.object_type == 'product'){
            if (result_object.available == 'true') {
              elements_count++;
              productsHtml += createSearchResProductGrid(result_object, type);
            }
          }
        });

        $('#results_count').text(elements_count);
        $('#results_count_mobile').text(elements_count);
      }

      if(type == 'desktop') {
        if (productsHtml != '') {
          $('.ajax_search_products').html(productsHtml);
        } else {
          $('#results_count').text('0');
          $('.ajax_search_products').html("<h4>We didn't find any results for that! Try something else?</h4>");
        }
      } else {
        if (productsHtml != '') {
          $('.ajax_search_products_mobile').html(productsHtml);
        } else {
          $('#results_count_mobile').text('0');
          $('.ajax_search_products_mobile').html("<h4>We didn't find any results for that! Try something else?</h4>");
        }
      }
    },
    error: function (data) {
      console.log(data);
    }
	});
}

function createSearchResProductGrid(product, type) {
	var label_html = '';
	var product_url = product.url;

	if(product.available == 'true' && product.label != ''){
		label_html = '<span class="bestseller">' + product.label + '</span>';
	}
	var sold_out_class = '';
	if(product.available == 'false') {
		sold_out_class = 'soldout';
		label_html = '<span class="soldout">Sold Out</span>';
		product_url = 'javascript:void(0);';
	}

	if(type == 'desktop') {
		var html = '<div class="searchresultsdesktop-col ' + sold_out_class + '">\n' +
			'                    <a href="' + product_url + '"><div class="searchresultsdesktop-cover">' + label_html +
			//'                      <span class="quick-add" data-product-id="search_' + product.id + '" data-product-url="' + product.url + '"></span>' +
			//'        				 <div class="quick-add-modal" style="display: none" id="quick_modal_product_search_' + product.id + '"><div class="product-order-form-loading">Loading...</div><div class="product-order-form" style="display: none"></div></div>' +
			'                        <div class="standard-cover">' +
			'                            <img src="' + product.thumb + '" />' +
			'                        </div>' +
			'                    </div></a>' +
			'                    <a href="' + product_url + '">' + product.title + '</a>' +
			//'                    <!--span class="searchresultsdesktop-stars"><img src="img/stars-5.svg"></span-->' +
			'                    <span class="searchresultsdesktop-price">' + product.price + '</span>' +
			'                </div>';
	}else{
		var html = '<div class="searchresultsmobile-col">' +
			'                <a href="' + product_url + '"><div class="searchresultsmobile-cover">' + label_html +
			//'                    <span class="quick-add"></span>' +
			'                    <div class="standard-cover">' +
			'                        <img src="' + product.thumb + '" />' +
			'                    </div>' +
			'                </div></a>' +
			'                <a href="' + product_url + '">' + product.title + '</a>' +
			//'                <span class="searchresultsmobile-stars"><img src="img/stars-5.svg"></span>' +
			'                <span class="searchresultsmobile-price">' + product.price + '</span>' +
			'            </div>';
	}
	return html;
}

function quickCloseInit() {
	$('.quick-close').on('click', closeQuickModal);
}

function closeQuickModal() {
	$('.quick-add-modal').hide().removeClass('quick-add-modal-content-active');
	$('.quick-add-modal-content').empty();
	$('body').removeClass('body-modal-open body-overflow');
}

function swatchInit() {
	jQuery('.swatch :radio').change(function() {

		var swatch_id = $(this).data('swatch-id');
		var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
		var optionValue = jQuery(this).val();

		jQuery(this)
			.closest('form')
			.find('.single-option-selector_' + swatch_id)
			.eq(optionIndex)
			.val(optionValue)
			.trigger('change');

		var selected_variant_title = '';

		$('.single-option-selector_' + swatch_id).each(function(){

			if(selected_variant_title !='' ) {
				selected_variant_title = selected_variant_title + ' / ' + $(this).val();
			}else{
				selected_variant_title = $(this).val();
			}
		});

		$('.product-form__variants_' + swatch_id + ' option').each(function(){
			var option_variant_title = $(this).data('variant-title');
			if(option_variant_title == selected_variant_title){
				$(this).prop('selected',true);
			}
		});
	});
}
